<template>

<div class='MainLayout'>

    <!-- HEADER -->
    <div id="header">
        <headr ref="topheader"
            :color="headerOptions.color"
            :image="headerOptions.image"
        />
    </div>

    <slot></slot>

    <!-- FOOTER -->
    <footer id="footer">

        <foot />

    </footer>

</div>

</template>

<script>

import Headr from '@/comps/header'
import Foot from '@/comps/footer'


export default {
    props: {headerOptions: { default: () => ({})}},
    components: {Headr, Foot}
}
</script>

<style lang='scss'>

@import '~@/assets/scss/vars.scss';

@media only screen and (max-device-width: 1200px) {
    .MainLayout {
        width: 150%;
    }
}
@media only screen and (max-device-width: 950px) {
    .MainLayout {
        width: 150%;
    }
}
@media only screen and (max-device-width: 480px) {
    .MainLayout {
        width: 135%;
    }
}

.bg-light {
  background-color: $color-blue;
}

.bg-dark {
  background-color: $color-blue-dark;
}

.hero {
  min-height: 400px;
  padding-top: 20px;
  padding-bottom: 80px;

  &.home {
    background-image: url('~@/assets/img/cover.png');
    background-repeat: no-repeat;
    background-size: 550px;
    background-position: 130px bottom;

    padding-bottom: 100px;
  }

  &.account {
    min-height: 50px;
    padding-bottom: 0;
  }

  .top-main {
    width: 80%;
    margin: 130px auto 0;
    color: lighten($color-blue, 55%);

    img {
      width: 350px;
    }

    h1 {
      margin-top: 0;
      font-size: 1.9em;
    }

    p {
      font-size: 18px;
    }

    .text {
      padding-left: 115px;
    }

    button {
      margin-top: 30px;
      color: $color-blue-dark;
      background-color: white;
      box-shadow: 0 12px 18px -10px $color-blue-dark;
    }
  }
}

</style>



// WEBPACK FOOTER //
// apps/comps/MainLayout.vue